import { Controller } from "@hotwired/stimulus"

// Shows the racing sub-toggles only while the master switch is on.
//
// Nothing is persisted here on purpose. The reveal is *derived* from the
// master's own saved column, so the server already renders the right state and
// connect() only has to read it back off the switch — this survives a Turbo
// re-render without a localStorage round-trip. Sub-flag values are never
// touched when the master goes off, so re-enabling restores the last choice.
export default class extends Controller {
  static targets = ["master", "subs"]

  connect() {
    this.sync()
  }

  sync() {
    const on = this.masterTarget.getAttribute("aria-checked") === "true"
    this.subsTarget.classList.toggle("hidden", !on)
  }
}
